import moment from 'moment';

export default (dateString, isUTC = true, keepDate = false) => {
    if (!dateString) {
        return 'Unknown';
    }

    let date = moment(dateString);

    if (!date.isValid()) {
        return dateString === 'Snarest' ? 'Urgent' : dateString;
    }

    // Convert to UTC
    if (isUTC) {
        date = date.utc(false);
    }

    // Check if it is 23 hours left
    const now = moment();
    if (
        now.isAfter(moment(date).subtract(23, 'hours')) &&
        now.isBefore(date) &&
        !keepDate
    ) {
        return date.fromNow();
    }

    return date.format('LL');
};
